export default __webpack_public_path__ + "static/media/hungry.4493fc35.png";